export var tripartiteCooperationSocialMediaList = [{
  value: 'linkedin',
  label: 'LinkedIn',
  defaultWebUrl: 'https://www.linkedin.com/...'
}, {
  value: 'instagram',
  label: 'Instagram',
  defaultWebUrl: 'https://www.instagram.com/...'
}, {
  value: 'pinterest',
  label: 'Pinterest',
  defaultWebUrl: 'https://www.pinterest.com/...'
}, {
  value: 'facebook',
  label: 'Facebook',
  defaultWebUrl: 'https://www.facebook.com/...'
}];